import { isPlatformBrowser } from "@angular/common";
import { Component, effect, Inject, Input, OnInit, PLATFORM_ID } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PreviewProductModalComponent } from "../preview-product-modal/preview-product-modal.component";
import { PortalService } from "../../../core/services/portal.service";

@Component({
  selector: 'app-expansion-pannels',
  standalone: false,
  templateUrl: './expansion-panels.component.html',
  styleUrl: './expansion-panels.component.scss'
})
export class ExpansionPanelsComponent implements OnInit {
  @Input({ required: true }) group!: any;
  isOpen = false;
  primaryColor = ''

  onToogle() {
    this.isOpen = !this.isOpen;
  }
  constructor(
    private modalService: NgbModal,
    private portalService: PortalService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    effect(() => {
      if (!this.portalService.loaded()) return;
      const portal = this.portalService.portal()!;
      this.primaryColor = portal.style.primary_color
    });
  }
  ngOnInit(): void {

  }

  open(item: any, event?: Event) {
    if (!isPlatformBrowser(this.platformId)) return; 
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const ref = this.modalService.open(PreviewProductModalComponent, {
      centered: true,
      backdrop: 'static',
      animation: false,
      modalDialogClass: 'previewProductModalComponent'
    });
    if (Array.isArray(item.imageList) && item.imageList.length > 0) {
      ref.componentInstance.imageList = this.chunkArray<string>(item.imageList)
    } else {
      ref.componentInstance.imageList = []
    }
    
    ref.componentInstance.title = item.title;
    ref.componentInstance.message = item.description;
    ref.componentInstance.downloadUrl = item.href;
    ref.componentInstance.thumbnailUrl = item.thumbnailUrl;

    ref.result.then(
      (ok) => console.log('OK:', ok),
      () => console.log('Dismiss')
    );
  }

  private chunkArray<T>(arr: T[], size = 3): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  trackByHref = (_: number, item: { href: string }) => item.href;

  hasHref(item: any): boolean {
    return !!String(item?.href ?? '').trim();
  }
}
